import * as types from 'misc/types';
import * as actions from 'misc/actions';

const envelopes = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_ENVELOPES_ARCHIVES_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_ENVELOPES_ARCHIVES_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_ENVELOPES_ARCHIVES_GET.FAILURE:
            return actions.error(state, action.error);

        default:
            return state;
    }
};

export default envelopes;



// WEBPACK FOOTER //
// ./src/reducers/envelopes_archives.js